<template>
  <v-container fluid style="position: relative; padding: 0" class="secondary mainHomeContainer" app>
    <v-flex id="appJumbotron" class="appPadding primary--text">
      <div class="jumbotronHeader">Reveal what matters.</div>
      <v-layout row style="flex: none">
        <div class="jumbotronSubHeader">Our projects will allow you to monitor, analyze, and report valuable information for your business.</div>
        <v-spacer></v-spacer>
        <div class="identityLine"></div>
      </v-layout>
      <div class="jumbotronActions">
        <v-btn :ripple="false" round flat @click="goToDemo()" class="accent secondary--text hoverBlue">TRY FREE DEMO</v-btn>
        <v-btn :ripple="false" round outline flat @click="$router.push({ path: '/market' })" class="blueContent accent--text hoverTransparent">FIND A PROJECT</v-btn>
      </div>
      <div class="jumbotronArrow">
        <img src="@/assets/jumbotronArrow.png"/>
      </div>
    </v-flex>
    <v-flex class="companyInformation appPadding">
      <div style="margin-top: 135px; margin-bottom: 90px; font-size: 36px; font-weight: 800; text-align: center" class="primary--text">We combine...</div>
      <div style="height: 353px; display: flex; justify-content: space-between">
        <div class="combinedElements">
          <div class="combinedElementsIconContainer">
            <lottie :options="dataAnimationOptions" :height="150" :width="111" ref="dataAnimation"/>
          </div>
          <p class="elementTitle primary--text">Big Data</p>
          <p class="elementText primary--text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore.</p>
        </div>
        <div class="combinedElements">
          <div class="combinedElementsIconContainer">
            <lottie :options="techAnimationOptions" :height="150" :width="150" ref="techAnimation"/>
          </div>
          <p class="elementTitle primary--text">Technology</p>
          <p class="elementText primary--text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
        </div>
        <div class="combinedElements">
          <div class="combinedElementsIconContainer">
            <lottie :options="humanAnimationOptions" :height="150" :width="130" ref="humanAnimation"/>
          </div>
          <p class="elementTitle primary--text">Human Intervention</p>
          <p class="elementText primary--text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.</p>
        </div>
      </div>
      <div style="margin-top: 120px; display: flex; justify-content: center">
        <div class="verticalIdentityLine"></div>
      </div>
      <div style="margin-top: 120px; margin-bottom: 90px; font-size: 36px; font-weight: 800; text-align: center" class="primary--text">To provide...</div>
      <div style="height: 353px; display: flex; justify-content: center">
        <div class="combinedElements" style="max-width: 50%;">
          <div class="combinedElementsIconContainer">
            <lottie :options="valueAnimationOptions" :height="150" :width="115" ref="valueAnimation"/>
          </div>
          <p class="elementTitle primary--text">Valuable Information</p>
          <p class="elementText">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
        </div>
      </div>
    </v-flex>
    <v-flex xs12 class="trendingProjects primary">
      <div class="trendingTitle secondary--text">Most Active Projects</div>
      <div class="trendingProjectsCards" ref="trendingProjectsCards">
        <v-flex v-for="item in trendingProjects" :key="item.id" class="carousel-cell trendingProjectContainer" @click="$router.push({ path: '/market' })" style="cursor: pointer;">
          <div class="trendingOverlay"></div>
          <img class="trendingProjectImg" :src="getThumbnailImage(item)"/>
          <div class="projectInfo">
            <div class="trendingProjectName secondary--text">{{item.name}}</div>
            <div class="trendingProjectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
        </v-flex>
      </div>
      <div class="trendingProjectsActions">
        <v-btn :ripple="false" round flat @click="goToDemo()" class="primary--text secondary hoverWhite">TRY FREE DEMO</v-btn>
        <v-btn :ripple="false" round outline flat @click="$router.push({ path: '/market' })" color="secondary" class="hoverTransparent">FIND A PROJECT</v-btn>
      </div>
    </v-flex>
    <v-flex xs12 class="whyUs appPadding">
      <v-layout row>
        <v-flex xs6 style="display: flex; justify-content: center;flex-direction: column">
          <div style="font-size: 36px; font-weight: 800;" class="primary--text">Why Yakshof market?</div>
          <ul style="margin-top: 32px; font-size: 18px; font-weight: 300" class="primary--text">
            <li>Lorem ipsum dolor sit amen vita lorem.</li>
            <li>Lorem ipsum dolor sit amen vita lorempsum dolor sit amen vita lorem.</li>
            <li>Lorem ipsum dolor sit ampsum dolor sit amen vita loremem.</li>
            <li>Lorem ipsum dolor sit psum dolor sit amen vita loremn vita lorem.</li>
          </ul>
        </v-flex>
        <v-flex xs6 style="text-align: center">
          <img src="@/assets/whyUs.png" style="max-width: 100%;">
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="demoBanner appPadding highlight">
      <div class="demoBannerContent">
        <v-layout row>
          <div style="display: flex; align-items: center; font-size: 36px; font-weight: 800" class="primary--text">We will help you make more informed decisions.</div>
          <v-spacer></v-spacer>
          <v-btn :ripple="false" round flat @click="goToDemo()" class="navyFill primary secondary--text hoverNavy">TRY FREE DEMO</v-btn>
        </v-layout>
      </div>
    </v-flex>
  </v-container>
</template>

<style>
  .appPadding{
    padding: 0px 5%;
  }
  #appJumbotron{
    width: 100%;
    height: 730px;
    display: flex;
    position: relative;
    justify-content: center;
    flex-direction: column;
  }
  .jumbotronHeader{
    font-weight: 800;
    font-size: 48px;
  }
  .jumbotronSubHeader{
    font-weight: 300;
    font-size: 24px;
  }
  .identityLine{
    width: 120px;
    border-bottom: 3px solid #1226AA;
  }
  .verticalIdentityLine{
    height: 120px;
    border-left: 3px solid #1226AA;
  }
  .hoverOverlay{
    position:absolute;
    bottom:5px;
    right: 0;
    background-color: rgba(0, 0, 0, 0.8);
    left:0
  }
  .jumbotronArrow{
    position: absolute;
    left: 5%;
    right: 5%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .blueContent{
    border-color: #1226AA !important;
  }
  .jumbotronActions{
    margin-top: 35px;
  }
  .jumbotronActions button{
    margin-left: 0;
    margin-right: 30px;
    height: 50px;
    padding: 0 35px;
  }
  .jumbotronActions .v-btn__content{
    font-weight: 300;
    font-size: 18px;
  }
  .companyInformation{
    margin-bottom: 90px;
  }
  .combinedElements{
    text-align: center;
    max-width: 28%;
  }
  .combinedElements .elementTitle{
    margin-bottom: 40px;
    font-size: 24px;
    font-weight: 800;
  }
  .combinedElements .elementText{
    font-size: 18px;
    font-weight: 300;
  }
  .combinedElementsIconContainer{
    height: 180px;
  }
  .trendingProjects{
    min-height: 584px;
    padding: 100px 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .trendingProjects img{
    max-width: 280px
  }
  .trendingTitle{
    width: 100%;
    text-align: center;
    font-size: 36px;
    font-weight: 800;
  }
  .trendingProjectsCards{
    height: 185px;
    position: relative;
    width: 100%;
  }
  .trendingProjectContainer{
    position: relative;
    flex: none;
    height: 185px;
    width: 280px;
    margin-right: 10px
  }
  .trendingOverlay{
    background: #000000;
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .projectInfo{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 25px;
    z-index: 6;
  }
  .trendingProjectName{
    font-size: 20px;
    font-weight: 700;
  }
  .trendingProjectOrganization{
    font-weight: 700;
    font-size: 12px;
  }
  .trendingProjectsActions button{
    padding: 0 35px;
  }
  .trendingProjectsActions .v-btn__content{
    font-size: 18px;
    font-weight: 300;
  }
  .whyUs{
    height: 733px;
    display: flex;
    align-items: center;
  }
  .demoBanner{
    height: 172px;
    display: flex;
    align-items: center;
  }
  .demoBannerContent{
    width: 80%;
  }
  .navyFill{
    height: 50px;
    padding: 0 35px;
  }
  .navyFill .v-btn__content{
    font-size: 18px;
    font-weight: 300;
  }
  .hoverTransparent:hover:before{
    background-color: transparent;
  }
  .hoverWhite:hover:before{
    background-color: white;
  }
  .hoverNavy:hover:before{
    background-color: #011E41;
  }
  .hoverBlue:hover:before{
    background-color: #1226AA;
  }
</style>

<script>
import axios from 'axios'
import Lottie from 'vue-lottie'
import * as dataAnimation from '@/assets/dataAnimation.json'
import * as humanAnimation from '@/assets/humanAnimation.json'
import * as techAnimation from '@/assets/techAnimation.json'
import * as valueAnimation from '@/assets/valueAnimation.json'
import Flickity from 'flickity'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      clipped: false,
      animationPlayed: false,
      homePageActiveTab: 0,
      direction: 'down',
      valueDirection: 'down',
      previousScroll: 0,
      newScroll: 0,
      trendingProjectsFlickity: null,
      trendingTimePeriod: 7,
      dataAnimationOptions: {
        animationData: dataAnimation,
        animationSpeed: 1,
        loop: false,
        autoplay: false
      },
      humanAnimationOptions: {
        animationData: humanAnimation,
        animationSpeed: 1,
        loop: false,
        autoplay: false
      },
      techAnimationOptions: {
        animationData: techAnimation,
        animationSpeed: 1,
        loop: false,
        autoplay: false
      },
      valueAnimationOptions: {
        animationData: valueAnimation,
        animationSpeed: 1,
        loop: false,
        autoplay: false
      },
      trendingProjects: []
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    goToDemo () {
      window.open('https://app.dataslicer.io/#/demo', '_blank')
    },
    getOrganizationName (project) {
      var organization = project.organizations.find(item => { return item.id === project.createdByOrganizationId })
      if (organization) {
        return organization.name
      }
      return ''
    },
    getThumbnailImage (project) {
      return (project && project.config) ? project.config.unsplashImageUrl : ''
    },
    initializeTrendingProjectsFlickity () {
      var carouselElement = document.querySelector('.trendingProjectsCards')
      var carouselElementCells = document.querySelectorAll('.trendingProjectsCards .carousel-cell')
      if (carouselElementCells.length > 0) {
        this.trendingProjectsFlickity = new Flickity(carouselElement, {
          cellAlign: 'left',
          pageDots: false,
          contain: true,
          groupCells: true
        })
      }
    }
  },
  mounted: function () {
    var today = new Date()
    var todayQueryString = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    var timePeriodStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - this.trendingTimePeriod)
    var timePeriodStartQueryString = timePeriodStart.getFullYear() + '-' + (timePeriodStart.getMonth() + 1) + '-' + timePeriodStart.getDate()
    var query = '?projectStatus=Active&sortBy=_total_subscriptions%20desc,_date_added%20desc&pageSize=15&fromDate=' + timePeriodStartQueryString + '&toDate=' + todayQueryString
    axios.all([this.$store.dispatch('getProjectsWithAllAndStatsPublic', query)]).then(axios.spread((response) => {
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload.length > 0) {
          this.trendingProjects = []
          this.trendingProjects = JSON.parse(JSON.stringify(response.data.payload))
        }
        var self = this
        setTimeout(function () {
          self.initializeTrendingProjectsFlickity()
        }, 50)
      } else {
        this.notify({message: 'Something went wrong.', show: true})
      }
    })).catch((err) => {
      this.notify({message: 'Something went wrong while connecting to the server.', show: true})
      console.log(err)
    })
    var self = this
    window.onscroll = () => {
      if (!self.isLoggedIn && (self.$route.path.includes('home') || self.$route.path === '/') && self.$refs.dataAnimation && self.$refs.dataAnimation.anim && self.$refs.humanAnimation && self.$refs.humanAnimation.anim && self.$refs.techAnimation && self.$refs.techAnimation.anim && self.$refs.valueAnimation && self.$refs.valueAnimation.anim) {
        self.previousScroll = self.newScroll
        self.newScroll = document.documentElement.scrollTop
        if (self.newScroll > self.previousScroll) {
          if (document.documentElement.scrollTop > 400 && self.direction === 'down') {
            self.$refs.dataAnimation.anim.setDirection(1)
            self.$refs.humanAnimation.anim.setDirection(1)
            self.$refs.techAnimation.anim.setDirection(1)
            self.$refs.dataAnimation.anim.goToAndPlay(0)
            self.$refs.humanAnimation.anim.goToAndPlay(0)
            self.$refs.techAnimation.anim.goToAndPlay(0)
            self.animationPlayed = true
            self.direction = 'up'
          }
          if (document.documentElement.scrollTop > 1250 && self.valueDirection === 'down') {
            self.$refs.valueAnimation.anim.setDirection(1)
            self.$refs.valueAnimation.anim.play()
            self.valueDirection = 'up'
          }
        } else if (self.newScroll < self.previousScroll) {
          if (document.documentElement.scrollTop < 550 && self.direction === 'up') {
            self.$refs.dataAnimation.anim.setDirection(-1)
            self.$refs.humanAnimation.anim.setDirection(-1)
            self.$refs.techAnimation.anim.setDirection(-1)
            self.$refs.dataAnimation.anim.play()
            self.$refs.humanAnimation.anim.play()
            self.$refs.techAnimation.anim.play()
            self.direction = 'down'
          }
          if (document.documentElement.scrollTop < 1400 && self.valueDirection === 'up') {
            self.$refs.valueAnimation.anim.setDirection(-1)
            self.$refs.valueAnimation.anim.play()
            self.valueDirection = 'down'
          }
        }
      }
    }
  },
  components: {
    Lottie
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/HomeLoggedOut.vue